import React, { useContext, useEffect, useState } from "react";
import BarChartComp from "./myPredictions";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import charticon from "../../assets/icons/Path 23145.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getCopyPolster,
  getPartyList,
  getPollsterPrediction,
} from "../../redux/actions/pollingAction";
import { toTitleCase } from "../../helpers/TitleCase";
import PredictionStepper from "../../pages/prediction/predictionStepper";

const MakeYourselection = ({ freshPredict }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prediction, resetPrediction } = useContext(PredictionContext);
  console.log("🚀 ~ MakeYourselection ~ prediction:", prediction)
  const params = useParams();
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.get("select");
  const [pollsterId, setPollsterId] = useState([]);

  // console.log("searchParam", searchParam);

  const {
    PartyListResponse,
    CopyBestPosterResponse,
    PolsterPredictionListingResponse,
  } = useSelector((state) => state?.pollWeb);
    console.log("🚀 ~ MakeYourselection ~ CopyBestPosterResponse:", CopyBestPosterResponse)

  // console.log("CopyBestPosterResponse", prediction?.selectCountry?.id);
  const countryId = prediction?.selectCountry?.id;
  const state = prediction?.electionTypeData?.state;

  useEffect(() => {
    dispatch(getCopyPolster(searchParam));
    dispatch(
      getPollsterPrediction({
        slug: searchParam,
        country: countryId,
        state: state,
      })
    );
    dispatch(
      getPartyList({
        country: prediction?.selectCountry?.id,
          state: prediction?.electionTypeData?.state ?? null,
      })
    );
    if (prediction?.selectCountry === null) {
      navigate("/prediction");
    }
  }, [params.id, searchParam]);

const predictionbuttonArray = [
    { label: "New Prediction", path: "" },
    // { label: "Completed Predictions", path: "" },
    { label: "My Live Predictions", path: "/prediction" },
    { label: "Followed Predictions", path: "/prediction/followed_prediction" },
    // { label: "Followed Profiles", path: "" },
  ];
  const handleCopyPollster = (rowId) => {
    setPollsterId((prev) => [...prev, rowId]);
  };

  // ⏮️ Handle back to listing view
  // const handleGoToLivePredictions = () => {
  //   resetPrediction(); // ← resets to default and shows table again
  //   navigate("/prediction");
  // };

  // console.log("pollsterId", pollsterId);

  const handleCopySelection = () => {
    if (pollsterId?.length > 0) {
      navigate(
        `/prediction/new/modifyPrediction/${prediction?.electionTypeData?.state}?select=${searchParam}&pollster=[${pollsterId}]`
      );
    } else {
      alert("please copy first");
    }
  };
  const handleNavigate = (path, label) => {
    if (path) {
      if (label === "Followed Predictions") {
        navigate(path);
      } else {
        window.location.reload();
      }
    }
  };
  return (
    <>
      <div className="bg_home flex flex-col pb-8 h-auto">
        <div className="bg_home md:bg-[#F7F8FA] md:px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5 h-auto">
          <div className="bg-white w-full rounded-xl shadow-sm md:p-5">
            <div className="px-1">
              <div className="my-2 text-[12px] text-[#7F8FA4] hidden sm:flex">
                {prediction?.selectCountry?.name && (
                  <div className="">{prediction?.selectCountry?.name}</div>
                )}
                {prediction?.electionTypeData?.type &&
                  prediction?.predictionTitle && (
                    <div className="mx-1">
                      {`> ${
                        prediction?.electionTypeData?.type
                      }  > ${toTitleCase(prediction?.predictionTitle).replace(
                        "_",
                        " "
                      )}`}{" "}
                    </div>
                  )}
              </div>
            </div>
            <PredictionStepper />
            {/* <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 justify-start gap-1 md:gap-4 items-center p-3">
              {predictionbuttonArray?.map((label, index) => {
                return (
                  <div
                    key={index}
                    className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${
                      label === "New Prediction" && "bg-[#4252A8] text-white"
                    }`}
                    onClick={
                      () =>
                        label === "My Live Predictions" &&
                        handleGoToLivePredictions()
                      // console.log(label, "labell")
                    }
                  >
                    <img src={charticon} alt="chart-icon" width={12} />
                    {label}
                  </div>
                );
              })}
            </div> */}
            <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 justify-start gap-1 md:gap-4 items-center p-3">
              {predictionbuttonArray?.map((label, index) => {
                return (
                  <div
                    key={index}
                    className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${
                      label?.label === "New Prediction" &&
                      "bg-[#4252A8] text-white"
                    }`}
                    onClick={() => handleNavigate(label?.path, label?.label)}
                  >
                    <img src={charticon} alt="chart-icon" width={12} />
                    {label?.label}
                  </div>
                );
              })}
            </div>
            {!freshPredict ? (
              <div className="p-2 md:p-5">
                <h2 className="text-2xl font-semibold mb-4 text-[18px]">
                  Make your selection
                </h2>
                <div className=" rounded-2xl border-2 shadow-lg py-4 md:px-7 px-3 bg-white overflow-auto no-scrollbar">
                  {CopyBestPosterResponse && PartyListResponse?.partyData ? (
                    <table className="w-full border-collapse text-[14px]">
                      <thead>
                        <tr className="text-left">
                          <th className="p-2 min-w-[10rem]"></th>
                          {PartyListResponse?.partyData?.map((party) => {
                            return (
                              <th key={party.id} className="p-2">
                                {party?.abbreviation?.toUpperCase()}
                              </th>
                            );
                          })}
                          <th className="p-2">Overall Accuracy</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Mapping CopyBestPosterResponse */}
                        {CopyBestPosterResponse?.map((row, index) => (
                          <tr
                            key={index}
                            className={`${
                              index % 2 === 0 ? "bg-[#FCF3F0]" : "bg-[#E7F7FD]"
                            } `}
                          >
                            <td className="py-2 px-6 font-semibold">
                              {row?.displayName}
                            </td>
                            {/* Mapping PartyListResponse */}
                            {PartyListResponse?.partyData?.map((party) => {
                              const matchedField =
                                PolsterPredictionListingResponse?.find(
                                  (field) =>
                                    row?.id === field?.pollsterCategoryId &&
                                    party?.id === field?.partyId
                                );
                              return (
                                <td key={party.id} className="p-2">
                                  {/* <input
                                  type="text"
                                  value={matchedField ? matchedField.value : ""}
                                  className="w-[5rem] text-center p-1 rounded"
                                  readOnly
                                /> */}
                                  <p className="font-semibold">
                                    {matchedField ? matchedField.value : ""}%
                                  </p>
                                </td>
                              );
                            })}
                            <td key={"Overall Accuracy"} className="p-2">
                              <input
                                type="text"
                                disabled
                                value={`${
                                  (index === 0 &&
                                    PolsterPredictionListingResponse?.[0]
                                      ?.accuracy) ||
                                  0
                                }${row?.category !== "seats" ? "%" : ""}`}
                                className={`w-[5rem] text-center p-1 rounded font-semibold bg-[#DCDFE3]`}
                              />
                            </td>
                            <td>
                              <button
                                className={`px-7 py-1 rounded-xl text-white ${
                                  pollsterId?.includes(row?.id)
                                    ? "bg-[#5F6368]"
                                    : "bg-[#4252A8]"
                                }`}
                                onClick={() => handleCopyPollster(row?.id)}
                              >
                                {pollsterId?.includes(row?.id)
                                  ? "Copied"
                                  : "Copy"}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <>No data available</>
                  )}
                  <div className="flex justify-end gap-3 mt-4 text-[14px]">
                    <button
                      className="bg-[#4252A8] text-white px-6 py-2 rounded-xl"
                      onClick={handleCopySelection}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {freshPredict && (
                  <div className="mt-8">
                    <BarChartComp />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MakeYourselection;
